@if (visible) {
<div class="chatbot-widget">
  @if (loaded) {
    <div class="chatbot-widget__panel" [class.chatbot-widget__panel--open]="isOpen">
      <div class="chatbot-widget__header">
        <span class="chatbot-widget__title">Chat with us</span>
        <button type="button" class="chatbot-widget__close" aria-label="Close chat" (click)="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <iframe
        class="chatbot-widget__frame"
        [src]="safeUrl"
        title="Chatbot"
        allow="clipboard-write"
        referrerpolicy="strict-origin-when-cross-origin">
      </iframe>
    </div>
  } @else if (isOpen) {
    <div class="chatbot-widget__panel chatbot-widget__panel--open">
      <div class="chatbot-widget__header">
        <span class="chatbot-widget__title">Chat with us</span>
        <button type="button" class="chatbot-widget__close" aria-label="Close chat" (click)="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div class="chatbot-widget__status">
        @if (authorizing) {
          <span>Connecting…</span>
        } @else if (authError) {
          <span>Unable to start the chat right now.</span>
          <button type="button" class="chatbot-widget__retry" (click)="retry()">Retry</button>
        }
      </div>
    </div>
  }

  <button
    type="button"
    class="chatbot-widget__launcher"
    [class.chatbot-widget__launcher--active]="isOpen"
    [attr.aria-expanded]="isOpen"
    aria-label="Open chat"
    (click)="toggle()">
    <i class="fa fa-comments" aria-hidden="true"></i>
  </button>
</div>
}
